import React, { useEffect, useState } from 'react'
import * as Icons from 'react-icons/md'

const WidgetOption = ({widget, setSelected}) => {
    // const [checked, setChecked] = useState(false)

    // useEffect(() => {
    //     if(isShow === false){
    //         setSelected(0)
    //         // setCheck(false)
    //     }
    // }, [isShow])

    const DynamicMdIcon = ({ name }) => {
        const IconComponent = Icons[name];
      
        if (!IconComponent) { // Return a default one
          return <Icons.MdExtensionOff className="text-gray-700 w-9 h-9" />;
        }
      
        return <IconComponent className="text-gray-700 w-9 h-9"/>;
      };


    return (
        <div className={`bg-gray  relative
                        w-20 h-20 flex flex-col justify-center items-center 
                        rounded-lg cursor-pointer `}
        >
            <input 
                type="radio"
                value={widget.id} 
                onChange={(e) => setSelected(e.target.value)} 
                name="widget"
                className='absolute top-1 right-1'
                // checked={checked}
                
            />
            <DynamicMdIcon name={widget.icon} />
            <p 
                className='text-gray-700 font-semibold text-center text-sm w-16'
            >
                {widget.title}
            </p>
        </div>
    )
}

export default WidgetOption